import { Component, OnInit, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { first } from 'rxjs/operators'
import { ToastrService } from 'ngx-toastr';
import { FeedbackService } from 'src/app/core/helpers/feedback.service';
import { TranslateService } from '@ngx-translate/core';
// import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { GaService } from 'src/app/core/helpers/ga.service';

@Component({
  selector: 'loyaltic-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent implements OnInit {

  contactForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private router: Router,
    private contactService: FeedbackService,
    @Inject('ImagePath') public ImagePath,
    public translate: TranslateService,
    // private gtmService: GoogleTagManagerService,
    public gaService: GaService,
  ) { }

  ngOnInit() {
    this.contactForm = this.formBuilder.group({
      name: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(100)]],
      email: ['', [Validators.required, Validators.email]],
      //subject: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(100)]],
      message: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(1000)]]
    });
  }

  // convenience getter for easy access to form fields
  get f() { return this.contactForm.controls; }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.contactForm.invalid) {
      return;
    }

    this.loading = true;

    this.contactService.sendMessage(
      this.f.name.value,
      this.f.email.value,
      //this.f.subject.value,
      this.f.message.value
    )
      .pipe(first())
      .subscribe(
        data => {
          // this.gtmService.pushTag({ event: 'feed-back', status: 'Success' });
          this.gaService.emitEvent('feedback', 'Feedback Screen');
          this.contactForm.reset();
          this.loading = false;
          this.contactForm.reset();
          this.contactForm.clearValidators();
          this.router.navigate(['/feedback/success'], { queryParams: { status: 'success' } });

        },
        error => {
          this.loading = false;
          this.router.navigate(['/feedback/success'], { queryParams: { status: 'failure' } });
        });
  }

}
